var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  "aria-hidden": "true"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2D2D",
  fillRule: "evenodd",
  d: "M10 0v8h8v2l-8.001-.001L10 18H8V9.999L0 10V8h8V0z"
})));
export default SvgPlus;